(() => {
  const hubs = document.querySelectorAll('[data-crg-selection-hub]');

  hubs.forEach((hub) => {
    const options = Array.from(hub.querySelectorAll('[data-crg-selection-option]'));
    const routes = Array.from(hub.querySelectorAll('[data-crg-selection-route]'));
    const title = hub.querySelector('[data-crg-selection-title]');
    const copy = hub.querySelector('[data-crg-selection-copy]');
    const target = hub.querySelector('[data-crg-selection-target]');
    const link = hub.querySelector('[data-crg-selection-link]');
    const index = hub.querySelector('.crg-home-selection__readout-index');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let activeIndex = 0;
    let timer;

    const setActive = (nextIndex) => {
      const nextOption = options[nextIndex];

      if (!nextOption) return;

      activeIndex = nextIndex;

      options.forEach((option, optionIndex) => {
        option.classList.toggle('is-active', optionIndex === activeIndex);
      });

      routes.forEach((route, routeIndex) => {
        route.classList.toggle('is-active', routeIndex === activeIndex);
      });

      if (title) title.textContent = nextOption.dataset.title || '';
      if (copy) copy.textContent = nextOption.dataset.copy || '';
      if (target) target.textContent = nextOption.dataset.target || '';
      if (link) link.href = nextOption.dataset.href || nextOption.href;
      if (index) index.textContent = String(activeIndex + 1).padStart(2, '0');
    };

    const stopRotation = () => {
      if (timer) window.clearInterval(timer);
      timer = undefined;
    };

    const startRotation = () => {
      if (prefersReducedMotion || timer || options.length < 2) return;
      timer = window.setInterval(() => {
        setActive((activeIndex + 1) % options.length);
      }, 3600);
    };

    options.forEach((option, optionIndex) => {
      option.addEventListener('mouseenter', () => {
        stopRotation();
        setActive(optionIndex);
      });

      option.addEventListener('focus', () => {
        stopRotation();
        setActive(optionIndex);
      });
    });

    hub.addEventListener('mouseleave', startRotation);
    hub.addEventListener('focusout', () => {
      window.setTimeout(() => {
        if (!hub.contains(document.activeElement)) startRotation();
      }, 0);
    });

    setActive(0);
    startRotation();
  });
})();
